import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Printer, MapPin, Search, HandHeart } from "lucide-react";

const SITE_URL = "https://fydate.it";

export default function Locandina() {
  const navigate = useNavigate();
  const [city, setCity] = useState("la tua zona");

  return (
    <Layout>
      <div className="max-w-xl mx-auto fade-in">
        <div className="flex items-center justify-between mb-4 no-print">
          <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-[#4A4E68] text-sm"><ArrowLeft size={16} /> Indietro</button>
          <Button data-testid="locandina-print" onClick={() => window.print()} className="rounded-full bg-[#FFD23F] hover:bg-[#F2C200] text-[#0F1230]">
            <Printer size={16} className="mr-1.5" /> Stampa / Salva PDF
          </Button>
        </div>

        <div className="bg-white border border-[#DADFEA] rounded-[18px] p-5 mb-4 no-print">
          <Label>Testo zona (modificabile)</Label>
          <Input data-testid="locandina-city" value={city} onChange={(e) => setCity(e.target.value)} className="mt-1" />
          <p className="text-xs text-[#4A4E68] mt-2">Personalizza la zona, poi premi <b>Stampa / Salva PDF</b>. Appendi la locandina in negozio, bar, bacheche o condividila nei gruppi.</p>
        </div>

        {/* Poster */}
        <div data-testid="locandina-poster" className="poster bg-[#EEF1F7] border border-[#DADFEA] rounded-[18px] p-10 text-center">
          <img src="/fydate-icon.png" alt="FYDATE" className="w-20 h-20 rounded-2xl object-cover mx-auto mb-3 shadow-sm" />
          <p className="font-serif text-4xl font-bold text-[#141A3A] tracking-tight">FYDATE</p>
          <p className="text-sm text-[#4A4E68] -mt-1 mb-6">La bacheca dei bisogni</p>

          <h1 className="font-serif text-3xl font-bold text-[#0F1230] leading-tight">
            Hai bisogno di un aiuto<br />nella tua zona?
          </h1>
          <p className="text-[#2A2E48] mt-3 mb-7 text-lg">Chiedi. Trova. Risolvi — vicino a te.</p>

          <div className="inline-block bg-white rounded-2xl border border-[#DADFEA] p-5 shadow-sm">
            <QRCodeCanvas value={SITE_URL} size={190} fgColor="#141A3A" bgColor="#FFFFFF" level="M" includeMargin />
          </div>
          <p className="text-[#141A3A] font-semibold text-xl mt-4">fydate.it</p>
          <p className="text-sm text-[#4A4E68] mb-7">Inquadra il QR con il telefono</p>

          <div className="flex items-center justify-center gap-6 text-left max-w-sm mx-auto">
            <div className="flex items-center gap-2 text-sm text-[#2A2E48]"><Search size={18} className="text-[#E8590C]" /> Idraulici, meccanici, ripetizioni…</div>
          </div>
          <div className="flex items-center justify-center gap-6 text-left max-w-sm mx-auto mt-2">
            <div className="flex items-center gap-2 text-sm text-[#2A2E48]"><HandHeart size={18} className="text-[#E8590C]" /> Offri i tuoi servizi e trova clienti</div>
          </div>

          <div className="mt-7 inline-flex items-center gap-1.5 text-sm text-[#141A3A] font-medium">
            <MapPin size={16} /> {city}
          </div>
        </div>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          header, footer, nav { display: none !important; }
          body, .poster { background: #fff !important; }
          .poster { border: none !important; }
          @page { margin: 12mm; }
        }
      `}</style>
    </Layout>
  );
}
